import React from 'react';
import { useIntl } from 'react-intl';
import Box from '@nubank/nuds-web/components/Box/Box';
import Grid from '@nubank/nuds-web/components/Grid/Grid';
import Image from '@nubank/nuds-web/components/Image/Image';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import { useBreakpointsMediaDown } from '@nubank/nuds-web/styles/breakpoints';

import RegistrationUnavailableLanguage from 'patterns/RegistrationUnavailableLanguage/RegistrationUnavailableLanguage';
import ShortForm from 'patterns/ShortForm/ShortForm';
import { DEFAULT_LOCALE } from 'utils/i18nUtils';
import { NU_CONTA } from 'utils/prospectTypes';

function SectionForm() {
  const { locale } = useIntl();
  const isMobile = useBreakpointsMediaDown('md');

  return (
    <Box
      tag="section"
      display="flex"
      minHeight={{ md: 'calc(100vh - 4rem)', lg: 'calc(100vh - 3.5rem)' }}
      position="relative"
      paddingBottom={{ xs: '12x', md: 56, lg: '32x' }}
      paddingTop={{ xs: '8x', md: '20x', lg: '32x' }}
      backgroundSize="cover"
      backgroundColor="white.dark"
      backgroundImage={{
        md: {
          '1x': 'roxinho-card-with-phone/roxinho-card-with-phone-md@1x.jpg',
          '2x': 'roxinho-card-with-phone/roxinho-card-with-phone-md@2x.jpg',
          '3x': 'roxinho-card-with-phone/roxinho-card-with-phone-md@3x.jpg',
        },
        lg: {
          '1x': 'roxinho-card-with-phone/roxinho-card-with-phone-lg@1x.jpg',
          '2x': 'roxinho-card-with-phone/roxinho-card-with-phone-lg@2x.jpg',
          '3x': 'roxinho-card-with-phone/roxinho-card-with-phone-lg@3x.jpg',
        },
      }}
    >
      <Grid
        alignItems={{ lg: 'center' }}
        gridTemplateRows={{ md: '0 auto 1fr', lg: '0 1fr' }}
      >
        <Grid.Child gridColumn={{ xs: '1 / -1' }}>
          {isMobile && (
            <Image
              srcSet={{
                xs: {
                  '1x': 'roxinho-card-with-phone/roxinho-card-with-phone-xs@1x.png',
                  '2x': 'roxinho-card-with-phone/roxinho-card-with-phone-xs@2x.png',
                  '3x': 'roxinho-card-with-phone/roxinho-card-with-phone-xs@3x.png',
                },
              }}
              altIntlKey="ACCOUNT.SECTION_FORM.IMAGE.ALT_TEXT"
            />
          )}
        </Grid.Child>
        <Grid.Child
          gridColumn={{ xs: '1 / span 4', md: '1 / span 6', lg: '1 / span 4' }}
        >
          <Typography
            textAlign={{ xs: 'center', md: 'left' }}
            variant="subtitle"
            marginBottom={{ xs: '2x' }}
            intlKey="cms.accountPage.heroTitle"
          />
          <Typography
            textAlign={{ xs: 'center', md: 'left' }}
            variant="title"
            marginBottom={{ xs: '6x', lg: '0' }}
            intlKey="cms.accountPage.heroDescription"
          />
        </Grid.Child>
        <Grid.Child
          gridColumn={{ xs: '1 / span 4', md: '4 / span 3', lg: '10 / span 3' }}
          alignSelf={{ md: 'end', lg: 'center' }}
        >
          {locale === DEFAULT_LOCALE ? (
            <Box marginBottom={{ lg: '40x' }}>
              <ShortForm
                initialField="cpf"
                prospectTypeKey={NU_CONTA}
                formTitle="SHORT_FORM.NUCONTA.FORM_TITLE"
                completeFormTitle="SHORT_FORM.NUCONTA.COMPLETE_FORM_TITLE"
                completeFormVerticalTitle="SHORT_FORM.NUCONTA.COMPLETE_FORM_VERTICAL_TITLE"
              />
            </Box>
          ) : (
            <RegistrationUnavailableLanguage isOpenForm isShortForm />
          )}
        </Grid.Child>
      </Grid>
    </Box>
  );
}

export default React.memo(SectionForm);
